module.exports = __webpack_public_path__ + "img/theme-dark.69e096cc.svg";